<template>
  <div class="product-accordion-items-list">
    <div class="product-accordion-items-list__toggle-btn">
      <span @click="toggleAll" v-if="productItems.length > 1">
        {{ allExpanded ? langJson[lang].minimizeAll : langJson[lang].expandAll }}
        <span :class="!allExpanded ? 'product-accordion-items-list__plus' : 'product-accordion-items-list__minus'"></span>
      </span>
    </div>
    <product-accordion-item
      v-for="(item, index) in productItems"
      :item="item"
      :key="index"
      :index="index"
      :allExpanded="allExpanded"
      @onToggle="toggleItem"
    />
  </div>
</template>

<script setup lang="ts">
  import { useMainStore } from '@/stores/main';
  import { privacyTypes } from '@/constants';

  interface ProductAccordionItem {
    publishedTo?: number;
    active?: boolean;
  }

  const props = defineProps<{
    items?: ProductAccordionItem[];
  }>();

  const mainStore = useMainStore();
  const langJson = computed(() => mainStore.langJson);
  const lang = computed(() => mainStore.lang);

  const allExpanded = ref(false);
  const productItems = ref((props.items || []).map((item) => ({ ...item })));

  const productItemsExternalCount = computed(() => productItems.value.filter((item) => item.publishedTo === privacyTypes.EXTERNAL).length);
  const expandedProductCount = computed(() => productItems.value.filter((item) => item.active).length);

  function toggleAll() {
    productItems.value = productItems.value.map((item) => ({
      ...item,
      active: !allExpanded.value
    }));
    allExpanded.value = !allExpanded.value;
  }

  function toggleItem(index: number) {
    productItems.value[index] = {
      ...productItems.value[index],
      active: !productItems.value[index].active
    };
    if (expandedProductCount.value === 0) {
      allExpanded.value = false;
    } else if (expandedProductCount.value === productItems.value.length) {
      allExpanded.value = true;
    }
  }

  onMounted(() => {
    productItems.value = productItems.value.map((item) => ({
      ...item,
      active: productItemsExternalCount.value === 1 && item.publishedTo === privacyTypes.EXTERNAL
    }));
  });
</script>
